import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { IconButton, IconButtonProps } from '@mui/material';
import { colorPalette, sxs } from '@qualifio/ui-commons';
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { SxStyles } from './utils/types';

const styles: SxStyles = {
  iconButton: {
    color: colorPalette.grey.main,
    backgroundColor: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colorPalette.grey.darkHover,
    },
  },
};

export interface TableIconButtonProps {
  buttonProps: IconButtonProps;
  iconProps: FontAwesomeIconProps;
  hoverColor: string;
}

export function TableIconButton({ iconProps, buttonProps, hoverColor }: TableIconButtonProps) {
  return (
    <IconButton
      sx={sxs(styles.iconButton, {
        '&:hover': {
          color: hoverColor,
        },
      })}
      {...buttonProps}
    >
      <FontAwesomeIcon {...iconProps} fixedWidth />
    </IconButton>
  );
}

export function EditIconButton(props: IconButtonProps) {
  return (
    <TableIconButton
      buttonProps={props}
      iconProps={{
        icon: faPencil,
      }}
      hoverColor={colorPalette.orange.main}
    />
  );
}
export function CopyIconButton(props: IconButtonProps) {
  return (
    <TableIconButton
      buttonProps={props}
      iconProps={{
        icon: faClone,
      }}
      hoverColor={colorPalette.turquoise.main}
    />
  );
}

export function DeleteIconButton(props: IconButtonProps) {
  return (
    <TableIconButton
      buttonProps={props}
      iconProps={{
        icon: faTrash,
      }}
      hoverColor={colorPalette.red.main}
    />
  );
}
